<div class="authentication-section">
	<div class="authentication-form-section">
		<img src="assets/login.png" class="authentication-image" />
		<!-- <img src="assets/rg_logo.png" class="authentication-image" /> -->
		<div class="authentication-heading-section">
			<span>Login</span>
		</div>
		<div class="authentication-description-section">
			<span>Please enter your email and password to login</span>
		</div>
		<ng-container *ngIf="!show_otp_view">
			<div class="authentication-input-section">
				<img
					src="assets/ic-user-onclick.png"
					class="authentication-input-image"
				/>
				<input
					type="text"
					placeholder="Email ID"
					class="authentication-input"
					[(ngModel)]="form_data.email"
					(keydown.enter)="login()"
				/>
				<p class="authentication-input-error" *ngIf="form_data_errors.email">
					Enter valid Email ID
				</p>
				<p class="authentication-input-error" *ngIf="globalError">
					Enter valid Credentials, Your account will be temporarily locked for 2
					hours after 3 unsuccessful login attempts
				</p>
				<p class="authentication-input-error" *ngIf="accountNotExistError">
					Account does not exist
				</p>
			</div>
			<div class="authentication-input-section">
				<img
					src="assets/ic-password-onclick.png"
					class="authentication-input-image"
				/>
				<input
					type="{{ password_active ? 'password' : 'text' }}"
					placeholder="Password"
					class="authentication-input"
					[(ngModel)]="form_data.password"
					(keydown.enter)="login()"
				/>
				<img
					src="assets/show-password.png"
					class="password-icons"
					*ngIf="password_active == false"
					(click)="password_active = true"
				/>
				<img
					src="assets/hide-password.png"
					class="password-icons"
					*ngIf="password_active == true"
					(click)="password_active = false"
				/>
				<p class="authentication-input-error" *ngIf="form_data_errors.passwotrd">
					Password cannot be empty
				</p>
			</div>
			<div class="authentication-input-section">
				<img
					src="assets/ic-user-onclick.png"
					class="authentication-input-image"
					style="top: 21px;"
				/>
				<mat-select class="authentication-input" [(ngModel)]="form_data.role">
					<mat-option [value]="''">Select Role</mat-option>
					<mat-option *ngFor="let role of roles_list" [value]="role.id">{{role.name}}</mat-option>
				</mat-select>
				<p class="authentication-input-error" *ngIf="form_data_errors.role">
					Role Cannot be Empty
				</p>
				<p class="authentication-input-error" *ngIf="roleNotExistError">
					Selected role doesnot exist for this user
				</p>
			</div>
			<div class="authentication-link-section">
				<span class="authentication-link" (click)="navigate('/forgot-password')">Forgot Password?</span>
			</div>
			<div class="authentication-action-section">
				<!-- <button class="authentication-action" (click)="generateOTP()" *ngIf="!login_loading_state">LOGIN</button>
				<button class="authentication-action" *ngIf="login_loading_state">
					<div class="loader-1 center"><span></span></div>
				</button> -->
				<button class="authentication-action" (click)="login()" *ngIf="!login_loading_state">LOGIN</button>
				<button class="authentication-action" *ngIf="login_loading_state">
					<div class="loader-1 center"><span></span></div>
				</button>
			</div>
		</ng-container>
		<ng-container *ngIf="show_otp_view">
			<div class="authentication-input-section">
				<img
					src="assets/ic-password-onclick.png"
					class="authentication-input-image"
				/>
				<input
					type="text"
					placeholder="OTP"
					class="authentication-input"
					[(ngModel)]="otp_value"
					(keydown.enter)="login()"
					(keypress)="numberOnly($event)"
					maxlength="6"
				/>
				<p class="authentication-input-error" *ngIf="otp_error">
					Enter valid OTP
				</p>
			</div>
			<div class="authentication-link-section">
				<span class="authentication-link" (click)="show_otp_view = false; otp_value = ''; otp_error = false;">Change Login Details</span>
			</div>
			<div class="authentication-action-section">
				<button class="authentication-action" (click)="login()" *ngIf="!login_loading_state">Submit</button>
				<button class="authentication-action" *ngIf="login_loading_state">
					<div class="loader-1 center"><span></span></div>
				</button>
			</div>
		</ng-container>
	</div>
	<div class="authentication-video-section">
		<!-- <video class="cmp-video-hero__video" muted="" autoplay="" loop="" playsinline="true" preload="auto">
			<source src="assets/animations/auth-animation.mp4" type="video/webm">
			<source src="assets/animations/auth-animation.mp4" type="video/ogg">
			<source src="assets/animations/auth-animation.mp4" type="video/mp4">
		</video> -->
		<video
		src="assets/animations/auth-animation.mp4"
		type="video/mp4"
		playsinline
		[autoplay]="true"
		[muted]="true"
		[loop]="true"
		[muted]="true"
		></video>
	</div>
</div>

<ng-template #accountDisabledModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section">
			<span>Security Alert</span>
			<span class="page-modal-close-icon" (click)="closeAccountDisabledModal()"
			>&times;</span
			>
		</div>
		<div class="page-modal-content-section">
			<p class="page-modal-delete-description">
				Your account is temporarily locked for 2 hours after 3 unsuccessful
				login attempts.
			</p>
		</div>
		<div class="page-modal-footer-section">
			<button
			class="page-modal-primary-button"
			(click)="closeAccountDisabledModal()"
			>
			OK
		</button>
	</div>
</div>
</ng-template>

<ng-template #passwordExpiryModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section">
			<span>Password Alert</span>
			<span class="page-modal-close-icon" (click)="closePasswordExpiryModal()"
			>&times;</span
			>
		</div>
		<div class="page-modal-content-section">
			<p class="page-modal-delete-description">
				Your password has expired after 90 days. Please reset it now for
				continued access to your account
			</p>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="reset()">Reset</button>
			<button
			class="page-modal-secondary-button"
			(click)="closePasswordExpiryModal()"
			>
			Cancel
		</button>
	</div>
</div>
</ng-template>
